import { useAuthStore } from '@/stores/auth'
import { setCookie } from '@/services/cookies'
import {
  doRequestOld as baseDoRequestOld,
  STATUS_CODES,
  doRequest as baseDoRequest,
  API_URL
} from './base'

const myBaseUrl = import.meta.env.VITE_DOMAIN_MY

export const enum REQUEST_METHODS {
  GET = 'get',
  POST = 'post',
  PATCH = 'patch',
  DELETE = 'delete'
}

/**
 * @Deprecated
 * Part of the migration to new responses
 * Use doRequest instead
 **/
export const doRequestOld = async (
  method: string,
  endpoint: string,
  data: any = {}
): Promise<any> => {
  const result = await baseDoRequestOld(method, endpoint, data)

  if (result && result.error && result.status_code == STATUS_CODES.UNAUTHORIZED) {
    const authStore = useAuthStore()
    authStore.clear()
    setCookie('signInExpired', 'true')
    window.location.replace(`${myBaseUrl}/sign_in`)
  } else {
    return result
  }
}

export const doRequest = async <T = any>(
  method: string,
  endpoint: string,
  data: any = {}
): Promise<T> => {
  try {
    return await baseDoRequest<T>(method, endpoint, data)
  } catch (error: any) {
    if (error?.statusCode == STATUS_CODES.UNAUTHORIZED) {
      const authStore = useAuthStore()
      authStore.clear()
      setCookie('signInExpired', 'true')
      window.location.replace(`${myBaseUrl}/sign_in`)
      return {} as T
    } else {
      throw error
    }
  }
}

/**
 * @Deprecated
 * Part of the migration to new responses
 * Use doPost instead
 **/
export const doPostOld = async (endpoint: string, data: any = {}): Promise<any> => {
  return doRequestOld(REQUEST_METHODS.POST, endpoint, data)
}

/**
 * @Deprecated
 * Part of the migration to new responses
 * Use doGet instead
 **/
export const doGetOld = async (endpoint: string): Promise<any> => {
  return doRequestOld(REQUEST_METHODS.GET, endpoint)
}

/**
 * @Deprecated
 * Part of the migration to new responses
 * Use doPatch instead
 **/
export const doPatchOld = async (endpoint: string, data: any = {}): Promise<any> => {
  return doRequestOld(REQUEST_METHODS.PATCH, endpoint, data)
}

/**
 * @Deprecated
 * Part of the migration to new responses
 * Use doDelete instead
 **/
export const doDeleteOld = async (endpoint: string): Promise<any> => {
  return doRequestOld(REQUEST_METHODS.DELETE, endpoint)
}

export const doGet = async <T = unknown>(endpoint: string): Promise<T> => {
  return doRequest(REQUEST_METHODS.GET, endpoint)
}

export const doPost = async <T = unknown>(endpoint: string, data: any = {}): Promise<T> => {
  return doRequest(REQUEST_METHODS.POST, endpoint, data)
}

export const doPatch = async <T = unknown>(endpoint: string, data: any = {}): Promise<T> => {
  return doRequest(REQUEST_METHODS.PATCH, endpoint, data)
}

export const doDelete = async <T = unknown>(endpoint: string): Promise<T> => {
  return doRequest(REQUEST_METHODS.DELETE, endpoint)
}

export const doDeleteKeepalive = (endpoint: string): void => {
  fetch(`${API_URL}${endpoint}`, {
    method: 'DELETE',
    keepalive: true,
    credentials: 'include'
  })
}

export default {
  doGetOld,
  doPostOld,
  doPatchOld,
  doDeleteOld,
  doGet,
  doPost,
  doPatch,
  doDelete,
  doDeleteKeepalive
}
